/**
 * Created by alex.y on 9/7/2017.
 */
import {Component, Input} from "@angular/core";
import {Location} from "../../../../objects/management/locationManagement/location";
import {LMCreateModalComponent} from "../locationModals/locationManagementCreateModal.component";
import {LocationType} from "../../../../objects/management/locationManagement/locationType";

@Component({
    selector: 'location-item',
    templateUrl: 'locationItem.component.html',
    moduleId: module.id.toString()
})
export class LocationItemComponent {

    @Input()
    public location: Location;

    @Input()
    public locationModal: LMCreateModalComponent;

    public string = String;

    public convertName(name: string): string {
        return String.getEnumValue(name, LocationType);
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/locationManagement/locationIitem/locationItem.component.ts